/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const PlusIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M16 7a1 1 0 0 0-1 1v7H8a1 1 0 1 0 0 2h7v7a1 1 0 1 0 2 0v-7h7a1 1 0 1 0 0-2h-7V8a1 1 0 0 0-1-1Z" />
    </BaseIcon>
  );
};
